import React, { useEffect, useState } from "react";
import Dropdown from "sushiweb/Dropdown";
import MenuItem from "sushiweb/MenuItem";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as DriverAssetsActions from "../../../store/actions/DriverAssets";
import "./OnboardingCenterInputBar.scss";
import Permission from "../../../components/Common/Permission";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const OnboardingCenterInputBar = (props) => {
  const {
    onboardingCenters,
    driverId,
    getDriverCities,
    getOnboardingCenters,
    setCenterId,
    error,
    setError,
  } = props;
  const [activeCities, setActiveCities] = useState([]);
  const allActions = MenuActionsMappings[MenuNames.DRIVER_ASSETS];

  const handleSelect = (val, type) => {
    if (type === "city") {
      getOnboardingCenters(val);
    } else {
      setError({});
      setCenterId(val);
    }
  };

  useEffect(() => {
    getDriverCities({ driver_id: driverId }).then((res) => {
      if (res) {
        if (Array.isArray(res)) {
          setActiveCities(res);
        } else {
          setActiveCities([res]);
        }
      }
    });
  }, [driverId]);
  return (
    <section className="onboarding-center-input">
      <h3 className="mt-0 text-black">Select Onboarding Center</h3>
      <div className="input-bar flex items-center justify-between ml-0">
        <Permission requiredPerms={[allActions.DRIVER_DETAIL]}>
          <Dropdown
            onSelect={(e) => handleSelect(e, "city")}
            data-testid="city-dropdown"
            id="city-dropdown"
            className="sushi-dropdown city-dropdown"
            width="250px"
            helperText="Select City"
          >
            {activeCities.map((city) => {
              return (
                <MenuItem value={city.id} key={city.id} label={city.name} />
              );
            })}
          </Dropdown>
        </Permission>
        <Permission requiredPerms={[allActions.CENTERS_IN_CITY]}>
          <Dropdown
            onSelect={(e) => handleSelect(e, "center")}
            className="sushi-dropdown"
            width="250px"
            helperText="Select Center"
            errorText={error && error.center ? error.center : ""}
          >
            {onboardingCenters.map((center) => {
              return (
                <MenuItem
                  className="sushi-menu"
                  toRight={true}
                  value={center.id}
                  key={center.id}
                  label={center.name}
                />
              );
            })}
          </Dropdown>
        </Permission>
      </div>
    </section>
  );
};

function mapStateToProps(state) {
  const { DriverAssets } = state;
  return {
    cities: DriverAssets.cities,
    onboardingCenters: DriverAssets.onboardingCenters,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getDriverCities: bindActionCreators(
      DriverAssetsActions.getDriverCities,
      dispatch
    ),
    getOnboardingCenters: bindActionCreators(
      DriverAssetsActions.getOnboardingCenters,
      dispatch
    ),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OnboardingCenterInputBar);
